import dayjs from "dayjs";
import {todayInfo} from "@/util/date";

export class Schedule {
  constructor(props = {}) {
    this.id = props.id
    this.date = props.date ? dayjs(props.date).toDate() : null
    this.holiday = props.holiday || false
    this.businessHour = props.businessHour || ''
    this.memo = props.memo || ''
    this.info = todayInfo({date: this.date})
  }

  formatedDate () {
    if (!this.date) {
      return ""
    }
    return dayjs(this.date).format("YYYY-MM-DD")
  }

  getDate() {
    return dayjs(this.date, 'YYYYMMDD').toDate();
  }

  isEqual(other = new Schedule({})) {
    return this.holiday === other.holiday &&
      this.businessHour === other.businessHour &&
      this.memo === other.memo
  }

  export = () => {
    return {
      date: dayjs(this.date).format("YYYYMMDD"),
      holiday: "true" === this.holiday,
      businessHour: this.businessHour,
      memo: this.memo
    }
  }
}
